import { Payload } from "@neworbit/redux-helpers";

import { loadAndTrack } from "redux-request-loading";

import { Dispatch } from "redux";

import { toast } from "@teamprevent/common/toasts";

import ActionableTasksApi from "./actionableTasksApi";
import * as models from "./models";
import * as actions from "./actionTypes";
import { ACTION_INSUFFICIENT_INFORMATION_TASK } from "./actionTypes";

import { push } from "redux-little-router";

export type ActionableTaskAction = ({type: typeof actions.LOAD_ACTIONABLE_TASKS_SUCCESS } & Payload<models.ActionableTasksListModel[]>)
| ({type: typeof actions.LOAD_ACTIONABLE_TASK_SUCCESS } & Payload<models.ActionableTaskDetailModel>)
| ({type: typeof actions.INSUFFICIENT_TASK_ACTIONED_SUCCESS } & Payload<boolean>);

export const loadActionableTasksSuccess = (payload: models.ActionableTasksListModel[]): ActionableTaskAction => ({
    payload,
    type: actions.LOAD_ACTIONABLE_TASKS_SUCCESS
});

export const loadActionableTaskSuccess = (payload: models.ActionableTaskDetailModel): ActionableTaskAction => ({
    payload,
    type: actions.LOAD_ACTIONABLE_TASK_SUCCESS
});

export const InsufficientTaskActionedSuccess = (payload: boolean): ActionableTaskAction => ({
    payload,
    type: actions.INSUFFICIENT_TASK_ACTIONED_SUCCESS
});

export function loadActionableTasks() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_ACTIONABLE_TASKS, ActionableTasksApi.getAll());
        dispatch(loadActionableTasksSuccess(result));
    };
}

export function loadActionableTask( { ohCaseId, taskId }: { ohCaseId: string; taskId: string } ) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadActionableTask", ActionableTasksApi.get(ohCaseId, taskId));
        dispatch(loadActionableTaskSuccess(result));
    };
}

export function actionInsufficientInformationTask(model: models.FollowUpInsufficientInformationModel) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, ACTION_INSUFFICIENT_INFORMATION_TASK, ActionableTasksApi.actionInsufficientInformationTask(model));
        if (result) {
            toast.success("Comments submitted successfully");
            dispatch(InsufficientTaskActionedSuccess(result));
            dispatch(push("/actions"));
        }
    };
}
